import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import Backdrop from "../../../UI/Backdrop/Backdrop";
import IntegrationMarketModal from "../Modal/IntegrationMarketModal";
import Field from "../../../../Pages/Settings/Content/Components/Field";
import CustomSelect from "../../../common/CustomSelect/CustomSelect";
import { CIFS_DEFAULT_PORT, buildMount, parseMount } from "../shareMount";

import {
  RequestSetConfig,
  RequestDeleteConfig,
  RequestUpdateConfig,
} from "../../../../store/actions/integrationsActions";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TYPE_OPTIONS = [
  { id: "cifs", value: "CIFS" },
  { id: "nfs", value: "NFS" },
  { id: "webdaw", value: "Webdaw" },
];

const BLOCK_OPTIONS = [
  { id: 1, value: "Enabled" },
  { id: 0, value: "Disabled" },
];

const WinshareSettings = ({ show, setShow, dataTmp = 0, setActiveInt }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [ip, setIP] = useState("");
  const [path, setPath] = useState("");
  const [port, setPort] = useState(CIFS_DEFAULT_PORT);
  const [type, setType] = useState(TYPE_OPTIONS[0]);
  const [bulk, setBulk] = useState(16);
  const [block, setBlock] = useState(BLOCK_OPTIONS[0]);
  const [confType, setConfType] = useState(false);

  const [ipError, setIPError] = useState(false);
  const [pathError, setPathError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [bulkError, setBulkError] = useState(false);
  const [hoverBack, setHoverBack] = useState(false);

  const getConfig = useSelector((state) => state.integrations.getConfig);
  const setConfig = useSelector((state) => state.integrations.setConfig);
  const deleteConfig = useSelector((state) => state.integrations.deleteConfig);
  const loadingUpdate = useSelector((state) => state.integrations.loadingUpdate);
  const loading = useSelector((state) => state.integrations.loading);

  let query = useQuery();
  let confTmp = parseInt(dataTmp);
  const isNfs = type?.id === "nfs";

  const selectType = (opt) => {
    if (opt.id === "nfs" && port === CIFS_DEFAULT_PORT) setPort("");
    if (opt.id !== "nfs" && !port) setPort(CIFS_DEFAULT_PORT);
  };

  const closePopupHandler = () => {
    cleanData();
    setShow(false);
    setActiveInt("");
    history.push("/integration-market");
  };

  const cleanData = () => {
    setIPError(false);
    setPathError(false);
    setUsernameError(false);
    setPasswordError(false);
    setBulkError(false);
    setUsername("");
    setPassword("");
    setType(TYPE_OPTIONS[0]);
    setIP("");
    setPath("");
    setPort(CIFS_DEFAULT_PORT);
    setBulk(16);
    setBlock(BLOCK_OPTIONS[0]);
  };

  useEffect(() => {
    if (query.get("t") === "add") {
      setConfType(true);
    } else if (query.get("t") === null) {
      setHoverBack(false);
      cleanData();
    } else {
      setConfType(false);
    }
  }, [query]);

  useEffect(() => {
    if (deleteConfig === "Success" && query.get("conf") === "winshare" && !loadingUpdate) {
      cleanData();
    }
  }, [deleteConfig]);

  useEffect(() => {
    if (setConfig === "Success" && query.get("conf") === "winshare" && !loadingUpdate) {
      cleanData();
    }
  }, [setConfig]);

  useEffect(() => {
    if (query.get("conf") === "winshare") {
      if (getConfig) {
        const configData = getConfig.config[confTmp];
        if (configData) {
          const mount = parseMount(configData);
          const typeValue =
            TYPE_OPTIONS.filter((opt) => opt.id === configData.mounttype)?.[0] || TYPE_OPTIONS[0];

          setUsername(mount.username);
          setPassword(mount.password);
          setType(typeValue);
          setIP(mount.ip);
          setPath(mount.path);
          setPort(mount.port);
          setBulk(configData?.bulk ?? 16);
          setBlock(
            BLOCK_OPTIONS.find((opt) => opt.id === Number(configData?.block ?? 1)) ||
              BLOCK_OPTIONS[0],
          );
        }
      }
    }
  }, [getConfig, confTmp]);

  const addConfig = () => {
    if (isValidInput()) {
      const config = {
        bulk: Number(bulk),
        block: block.id,
        mounttype: type.id,
        ...buildMount({ type: type.id, ip, path, username, password, port }),
      };
      const configString = JSON.stringify(config);
      const data = { appname: "winshare", config: configString };
      dispatch(RequestSetConfig(data));
    } else {
      console.log("Geçersiz giriş!");
    }
  };

  const updateConfigData = () => {
    if (isValidInput()) {
      const config = {
        bulk: Number(bulk),
        block: block.id,
        mounttype: type.id,
        ...buildMount({ type: type.id, ip, path, username, password, port }),
      };
      const configString = JSON.stringify(config);
      const data = {
        appname: "winshare",
        config: configString,
        mountpoint: getConfig?.config[confTmp]?.mountpoint,
      };
      dispatch(RequestUpdateConfig(data));
    } else {
      console.log("Geçersiz giriş!");
    }
  };

  const delConfig = () => {
    dispatch(
      RequestDeleteConfig({
        inttype: "winshare",
        mountpoint: getConfig?.config[confTmp]?.mountpoint,
      }),
    );
  };

  const isValidInput = () => {
    const ipPattern = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    const pathPattern = /^\/.*$/;

    if (
      ip.match(ipPattern) &&
      path.match(pathPattern) &&
      (isNfs || (username && password && port)) &&
      type &&
      bulk !== "" &&
      !isNaN(Number(bulk)) &&
      block
    ) {
      return true;
    } else {
      if (!ip.match(ipPattern)) {
        setIPError(true);
      } else {
        setIPError(false);
      }
      if (!path.match(pathPattern)) {
        setPathError(true);
      } else {
        setPathError(false);
      }
      if (!isNfs && !username) {
        setUsernameError(true);
      } else {
        setUsernameError(false);
      }
      if (!isNfs && !password) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }
      if (bulk === "" || isNaN(Number(bulk))) {
        setBulkError(true);
      } else {
        setBulkError(false);
      }
      return false;
    }
  };

  return show ? (
    <IntegrationMarketModal
      title="File Share"
      onBack={() => history.push("/integration-market?bck=" + query.get("conf"))}
      onClose={closePopupHandler}>
      <div className="winshare-settings">
        <div className="flex flex-align-items-center">
          {!isNfs && (
            <>
              <div className="flex-column m-r-10">
                <Field
                  label="Username*"
                  width="200px"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  tooltipText="Example format for domain users: user@domain.com"
                />
                {usernameError && <div className="error-message">Please enter a valid value.</div>}
              </div>

              <div className="flex-column m-r-10 relative">
                <Field
                  label="Password*"
                  width="200px"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  type="password"
                />
                {passwordError && <div className="error-message">Please enter a valid value.</div>}
              </div>
            </>
          )}

          <div className="flex-column relative">
            <p className="settings__label">Type</p>
            <CustomSelect
              data={TYPE_OPTIONS}
              select={type}
              setSelected={setType}
              onSelectItem={selectType}
              width={140}
              height={40}
            />
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column m-r-10">
            <Field
              label="IP*"
              width="200px"
              value={ip}
              onChange={(e) => setIP(e.target.value)}
              placeholder="Enter IP"
              tooltipText={
                isNfs
                  ? "NFS server IP. NFS has no username/password: the export must give this system's IP read-write access with no_root_squash."
                  : "Please enter a valid IP address (e.g., 192.168.1.1)"
              }
            />
            {ipError && <div className="error-message">Please enter a valid value.</div>}
          </div>

          <div className="flex-column m-r-10">
            <Field
              label="Path*"
              width="200px"
              value={path}
              onChange={(e) => setPath(e.target.value)}
              placeholder="Enter path"
              tooltipText={
                isNfs
                  ? "Export path on the NFS server, starting with '/' (e.g., /export/share)."
                  : "Please enter a valid path starting with a forward slash '/' (e.g., /file/path)."
              }
            />
            {pathError && <div className="error-message">Please enter a valid value.</div>}
          </div>

          <div className="flex-column">
            <Field
              label="Port"
              width="140px"
              value={port}
              onChange={(e) => setPort(e.target.value)}
              placeholder={isNfs ? "Default" : "Enter port"}
              tooltipText={isNfs ? "Leave empty to use the server's NFS port (2049)." : undefined}
            />
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column m-r-10">
            <Field
              label="Bulk*"
              width="200px"
              type="number"
              value={bulk}
              onChange={(e) => setBulk(e.target.value)}
              placeholder="Enter bulk"
              tooltipText="Number of files scanned per bulk batch."
            />
            {bulkError && <div className="error-message">Please enter a valid value.</div>}
          </div>

          <div className="flex-column relative">
            <p className="settings__label">Block</p>
            <CustomSelect
              data={BLOCK_OPTIONS}
              select={block}
              setSelected={setBlock}
              width={140}
              height={40}
            />
          </div>
        </div>
      </div>
      <div className="integration-market-modal__action">
        {confType ? (
          <button onClick={addConfig} className="primary-button">
            Add Config
          </button>
        ) : (
          <>
            <button onClick={updateConfigData} className="primary-button">
              Update
            </button>
            <button className="danger-button" onClick={delConfig}>
              Delete
            </button>
          </>
        )}
      </div>
      {(loading || loadingUpdate) && query.get("conf") === "winshare" && (
        <Backdrop show={loading || loadingUpdate} message="Please wait..." />
      )}
    </IntegrationMarketModal>
  ) : null;
};

export default WinshareSettings;
